<div class="p-4 md:p-6 max-w-4xl mx-auto">

  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">price_check</mat-icon>
      Reporte de Cierre de Caja
    </h1>
    <p style="color: #6b7280; font-size: 0.85rem; margin-top: 4px;">
      Genera reportes de cierre, línea de crédito y transacciones.
    </p>
  </div>

  <!-- ═══ Sección 1: Cierre de Caja ═══ -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-5">
    <div class="px-4 py-3 md:px-6 md:py-4" style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 2px solid #bbf7d0;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">point_of_sale</mat-icon>
        <span style="font-size: 1.05rem; font-weight: 700; color: #1e5a3f;">Cierre de Caja</span>
      </div>
    </div>

    <div class="p-4 md:p-6">
      <!-- Alerta -->
      <div style="display: flex; align-items: flex-start; gap: 10px; background: #fef3c7; padding: 12px 16px; border-radius: 10px; border: 1px solid #fde68a; margin-bottom: 20px;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #f59e0b; margin-top: 1px; flex-shrink: 0;">warning</mat-icon>
        <span style="font-size: 0.8rem; font-weight: 500; color: #92400e; line-height: 1.4;">
          Esta opción elimina todos los registros del archivo de cierre de caja y genera un nuevo archivo con los registros de la fecha seleccionada.
        </span>
      </div>

      <!-- Fecha + Botón -->
      <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
        <mat-form-field appearance="outline" class="modern-field w-full sm:w-auto" style="min-width: 200px;">
          <mat-label>Selecciona una fecha</mat-label>
          <input matInput [max]="maxDate" [matDatepicker]="picker" [(ngModel)]="selectedDate">
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <button type="button" (click)="closeCash()"
          class="w-full sm:w-auto"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">summarize</mat-icon>
          Generar reporte
        </button>
      </div>
    </div>
  </div>

  <!-- ═══ Sección 2: Línea de Crédito ═══ -->
  <ng-container *ngIf="role !== 'aguacate_retail_cashier'">
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-5">
      <div class="px-4 py-3 md:px-6 md:py-4" style="background: linear-gradient(135deg, #eff6ff, #dbeafe); border-bottom: 2px solid #bfdbfe;">
        <div style="display: flex; align-items: center; gap: 10px;">
          <mat-icon style="color: #2563eb; font-size: 24px; width: 24px; height: 24px;">credit_score</mat-icon>
          <span style="font-size: 1.05rem; font-weight: 700; color: #1e40af;">Línea de Crédito</span>
        </div>
      </div>

      <div class="p-4 md:p-6">
        <div style="display: flex; align-items: flex-start; gap: 10px; background: #fef3c7; padding: 12px 16px; border-radius: 10px; border: 1px solid #fde68a; margin-bottom: 20px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #f59e0b; margin-top: 1px; flex-shrink: 0;">warning</mat-icon>
          <span style="font-size: 0.8rem; font-weight: 500; color: #92400e; line-height: 1.4;">
            Esta opción elimina todos los registros del archivo de cierre de caja y genera un nuevo archivo con los registros de la fecha seleccionada.
          </span>
        </div>

        <div>
          <button type="button" (click)="creditLineReport()"
            class="w-full sm:w-auto"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 28px; background: #2563eb; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#1d4ed8'" onmouseout="this.style.background='#2563eb'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">credit_score</mat-icon>
            Generar reporte
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ═══ Sección 3: Aguacate Cambios (AC) ═══ -->
  <ng-container *ngIf="role !== 'aguacate_retail_cashier'">
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-5">
      <div class="px-4 py-3 md:px-6 md:py-4" style="background: linear-gradient(135deg, #fefce8, #fef9c3); border-bottom: 2px solid #fde68a;">
        <div style="display: flex; align-items: center; gap: 10px;">
          <mat-icon style="color: #ca8a04; font-size: 24px; width: 24px; height: 24px;">storefront</mat-icon>
          <span style="font-size: 1.05rem; font-weight: 700; color: #854d0e;">Aguacate Cambios - Detal</span>
        </div>
      </div>

      <div class="p-4 md:p-6">
        <div style="display: flex; align-items: flex-start; gap: 10px; background: #fef3c7; padding: 12px 16px; border-radius: 10px; border: 1px solid #fde68a; margin-bottom: 20px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #f59e0b; margin-top: 1px; flex-shrink: 0;">warning</mat-icon>
          <span style="font-size: 0.8rem; font-weight: 500; color: #92400e; line-height: 1.4;">
            Esta opción elimina todos los registros del archivo de cierre de caja de AguacateCambios y genera un nuevo archivo con los registros de la fecha seleccionada.
          </span>
        </div>

        <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
          <mat-form-field appearance="outline" class="modern-field w-full sm:w-auto" style="min-width: 200px;">
            <mat-label>Selecciona una fecha</mat-label>
            <input matInput [max]="maxDate" [matDatepicker]="pickerAC" [(ngModel)]="selectedDateAC">
            <mat-datepicker-toggle matIconSuffix [for]="pickerAC"></mat-datepicker-toggle>
            <mat-datepicker #pickerAC></mat-datepicker>
          </mat-form-field>

          <button type="button" (click)="ACReport()"
            class="w-full sm:w-auto"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 28px; background: #ca8a04; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#a16207'" onmouseout="this.style.background='#ca8a04'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">storefront</mat-icon>
            Generar reporte
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ═══ Sección 4: Reporte General ═══ -->
  <ng-container *ngIf="role !== 'aguacate_retail_cashier'">
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-5">
      <div class="px-4 py-3 md:px-6 md:py-4" style="background: linear-gradient(135deg, #fdf2f8, #fce7f3); border-bottom: 2px solid #fbcfe8;">
        <div style="display: flex; align-items: center; gap: 10px;">
          <mat-icon style="color: #be185d; font-size: 24px; width: 24px; height: 24px;">download</mat-icon>
          <span style="font-size: 1.05rem; font-weight: 700; color: #9d174d;">Reporte de Transacciones General</span>
        </div>
      </div>

      <div class="p-4 md:p-6">
        <div style="display: flex; align-items: flex-start; gap: 10px; background: #f0fdf4; padding: 12px 16px; border-radius: 10px; border: 1px solid #bbf7d0; margin-bottom: 20px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #16a34a; margin-top: 1px; flex-shrink: 0;">info</mat-icon>
          <span style="font-size: 0.8rem; font-weight: 500; color: #166534; line-height: 1.4;">
            Descarga un reporte de transacciones general en formato CSV seleccionando un rango de fechas.
          </span>
        </div>

        <!-- Fechas en grid responsive -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
          <mat-form-field appearance="outline" class="modern-field w-full">
            <mat-label>Fecha de inicio</mat-label>
            <input matInput [max]="maxDate" [matDatepicker]="pickerInicio" [(ngModel)]="fechaInicio">
            <mat-datepicker-toggle matIconSuffix [for]="pickerInicio"></mat-datepicker-toggle>
            <mat-datepicker #pickerInicio></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field w-full">
            <mat-label>Fecha de fin</mat-label>
            <input matInput [max]="maxDate" [matDatepicker]="pickerFin" [(ngModel)]="fechaFin">
            <mat-datepicker-toggle matIconSuffix [for]="pickerFin"></mat-datepicker-toggle>
            <mat-datepicker #pickerFin></mat-datepicker>
          </mat-form-field>
        </div>

        <button type="button" (click)="downloadGeneralReport()"
          class="w-full sm:w-auto"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 28px; background: #be185d; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#9d174d'" onmouseout="this.style.background='#be185d'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">file_download</mat-icon>
          Descargar reporte
        </button>
      </div>
    </div>
  </ng-container>

  <!-- ═══ Sección 5: Saldos Usuarios VE ═══ -->
  <ng-container *ngIf="role !== 'aguacate_retail_cashier'">
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-5">
      <div class="px-4 py-3 md:px-6 md:py-4" style="background: linear-gradient(135deg, #f5f3ff, #ede9fe); border-bottom: 2px solid #ddd6fe;">
        <div style="display: flex; align-items: center; gap: 10px;">
          <mat-icon style="color: #6d28d9; font-size: 24px; width: 24px; height: 24px;">account_balance_wallet</mat-icon>
          <span style="font-size: 1.05rem; font-weight: 700; color: #5b21b6;">Saldos Usuarios VE</span>
        </div>
      </div>

      <div class="p-4 md:p-6">
        <div style="display: flex; align-items: flex-start; gap: 10px; background: #f0fdf4; padding: 12px 16px; border-radius: 10px; border: 1px solid #bbf7d0; margin-bottom: 20px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #16a34a; margin-top: 1px; flex-shrink: 0;">info</mat-icon>
          <span style="font-size: 0.8rem; font-weight: 500; color: #166534; line-height: 1.4;">
            Descarga un reporte XLSX con el saldo VES y USDT de cada usuario tipo VE al cierre de la fecha seleccionada.
          </span>
        </div>

        <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
          <mat-form-field appearance="outline" class="modern-field w-full sm:w-auto" style="min-width: 200px;">
            <mat-label>Fecha de corte</mat-label>
            <input matInput [max]="maxDate" [matDatepicker]="pickerSaldosVe" [(ngModel)]="fechaSaldosVe">
            <mat-datepicker-toggle matIconSuffix [for]="pickerSaldosVe"></mat-datepicker-toggle>
            <mat-datepicker #pickerSaldosVe></mat-datepicker>
          </mat-form-field>

          <button type="button" (click)="downloadVesBalancesReport()"
            class="w-full sm:w-auto"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 28px; background: #6d28d9; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#5b21b6'" onmouseout="this.style.background='#6d28d9'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">file_download</mat-icon>
            Descargar reporte
          </button>
        </div>
      </div>
    </div>
  </ng-container>

</div>
